import { RootState } from "../../store";
import {
  ICollectionYardVisitEvents,
  ICollectionYardVisitEventsApi,
  ICollectionYardVisitEventsRequest,
  ICollectionYardVisitEventsSummary,
  ICollectionYardVisitEventsSummaryApi,
} from "../../types/collectionYardVisitEvents";
import { adaptFilterItemsForBe, adaptOrderingForBe } from "./adaptFiltersToBe";

export const adaptEventsResponseForFronted = (
  apiVisits: ICollectionYardVisitEventsApi[]
): ICollectionYardVisitEvents[] => {
  return apiVisits.map((apiVisit) => ({
    collectionYardEventId: apiVisit.collection_yard_event_id,
    collectionYardVisitId: apiVisit.collection_yard_visit_id,
    wasteTypeId: apiVisit.waste_type_id,
    netto: apiVisit.netto,
    price: apiVisit.price,
    rate: apiVisit.rate,
  }));
};

export const adaptEventsSummaryResponseForFronted = (
  apiVisit: ICollectionYardVisitEventsSummaryApi
): ICollectionYardVisitEventsSummary => {
  return {
    collectionYardVisitId: apiVisit.collection_yard_visit_id,
    created: apiVisit.created,
    collectionYardName: apiVisit.collection_yard_name,
    priceSum: apiVisit.price_sum,
    wasteSum: apiVisit.waste_sum,
    paidAt: apiVisit.paid_at,
  };
};

export const adaptRequestBodyForBackend = (
  state: RootState["collectionYardVisitEvents"]
): ICollectionYardVisitEventsRequest => {
  const { pagination, ordering, filters } = state;

  return {
    pagination,
    ordering: adaptOrderingForBe(ordering),
    filters: adaptFilterItemsForBe(filters.items),
  };
};
